export default function Vision() {
    return (
        <div className="section-padding flex flex-col gap-6 bg-cream">
            <h1 className="text-3xl lg:text-4xl text-slate-800 font-header font-bold">
                Vision
            </h1>
            <p className="text-slate-800 font-body lg:text-lg">
                <b>Led by two complementary specialists—one in education systems and one in patriarchal
                systems</b>—<b>Arise & Shine </b> offers a rapid, prevention-focused approach to mental health
                transformation. Together, we bring a systems-level understanding of how institutional structures,
                intergenerational trauma, and disconnection impact youth, families, and educators.
            </p>
            <p className="text-slate-800 font-body lg:text-lg">
                Our core offering is a <b>trauma-informed Wisdom Circle model</b>, rigorously tested with
                demonstrated success in building community, restoring connection, and strengthening relational
                capacity. The model centers <b>oral storytelling and shared inquiry</b>, developed in deep respect
                and acknowledgement of Indigenous knowledge traditions that have sustained community wisdom for generations.
            </p>
            <p className="text-slate-800 font-body lg:text-lg">
                Through intentional facilitation, we model <b>healthy relational leadership and the interruption
                of intergenerational trauma</b>, supporting adults to regulate, reconnect, and lead with presence.
                This work enables new legacies of care, belonging, and resilience to take root for children and youth.
            </p>
            <p className="text-slate-800 font-body lg:text-lg">
                <b>Arise & Shine’s</b> approach is <b>cost-effective, scalable, and aligned with existing education and
                community structures</b>. It is designed to support weary adults—parents, educators, and
                caregivers—who are carrying the responsibility of nurturing the most vulnerable population:
                our youth.
            </p>
            <p className="text-slate-800 font-body lg:text-lg">
                At a time when disconnection and burnout are escalating, we believe action must be taken now.
                Our work draws on globally validated, community-based practices that strengthen mental health
                not through crisis response alone, but through <b>daily relational culture</b>.
            </p>
            <p className="text-slate-800 font-body lg:text-lg">
                We are Wisdom Coaches committed to helping COMMUNITIES remember what works—CONNECTION,
                CURIOSITY, presence, story, and shared responsibility—and to restoring these foundations where
                they are needed most.
            </p>
        </div>
    );
}